const permissions = {
  hodFileReport: 4,
  fileAdminAccess: 5,
  userAdminAccess: 6,
  leaveAdminAccess: 7,
  unitLeaveAdminAccess: 8,
  kmsUploadAccess: 9,
  probationCompletionConfirmation: 10,
  probationCompletionInitiation: 11,
  deleteFileAccess: 12,
  dakAccess: 13,
  kmMenuAccess: 15,
  circularModule: 16,
  admin_emp_property: 3322,
  aparHRAccess: 17
};

export default {
  component: {
    home: { url: "/", permissionId: 0 },
    Esign: { url: "/esign", permissionId: 0 },
    contact: { url: "/support", permissionId: 0 },
    forgotPassword: { url: "/forgot-password", permissionId: 0 },
    resetPassword: { url: "/reset-password", permissionId: 0 },
    resetPasswordLink: { url: "/reset-password-link", permissionId: 0 },
    login: { url: "/login", permissionId: 0 },
    loginwithotp: { url: "/login-with-otp", permissionId: 0 },
    logout: { url: "/logout", permissionId: 0 },
    error: { url: "/error", permissionId: 0 },
    probationCompletionConfirmation: {
      url: "/probationCompletionConfirmation",
      permissionId: permissions.probationCompletionConfirmation,
    },
    probationCompletionInitiation: {
      url: "/probationInitiationInitiation",
      permissionId: permissions.probationCompletionInitiation,
    },
    // APAR management
    manageEmployee: { url: "/apar/manage-employee", permissionId: permissions.aparHRAccess },
    // Appraisal Cycle URLs
    startAppraisalCycle: { url: "/apar/appraisal-cycle", permissionId: permissions.aparHRAccess },
    aparAddAppraisalCycle: { url: "/apar/appraisal-cycle/add", permissionId: permissions.aparHRAccess },
    aparEditAppraisalCycle: { url: "/apar/appraisal-cycle/edit/:code", permissionId: permissions.aparHRAccess },
    viewReports: { url: "/apar/view-reports", permissionId: permissions.aparHRAccess },
    selfAppraisalList: { url: "/apar/self-appraisal", permissionId: 0 },
    selfAppraisal: { url: "/apar/self-appraisal/kpi", permissionId: 0 },
    selfAppraisalDetails: { url: "/apar/self-appraisal/details", permissionId: 0 },
    aparReportingAuthority: { url: "/apar/reporting-authority/:code", permissionId: permissions.aparHRAccess },
    // reportingManagerEmployees:{url: "/apar/reporting-manager-employees", permissionId: permissions.aparHRAccess},
    reportingManagerReport: {url: "/apar/reporting-manager-report", permissionId: 0 },
    appraisalReportingManager: {url: "/apar/appraisal-reporting-manager", permissionId: 0},
    // reviewingManagerEmployees: {url: "/apar/reviewing-manager-employees", permissionId: permissions.aparHRAccess},
    kpiApprovalReporting: {url: "/apar/kpi-approval/reporting", permissionId: 0},
    kpiApprovalReviewing: {url: "/apar/kpi-approval/reviewing", permissionId: 0},
    aparReportingManagerForm1: {url: "/apar/appraisal-report/add", permissionId: 0},
    aparReportingManagerForm2: {url: "/apar/appraisal-report/add-Weighted", permissionId: 0},
    aparReportingManagerForm3: {url: "/apar/appraisal-report/add-personal-attributes", permissionId: 0},
    aparReportingManagerForm4: {url: "/apar/appraisal-report/add-integrity-review", permissionId: 0},
    reviewingManagerReport: {url: "/apar/reviewing-manager-report", permissionId: 0 },
    appraisalReviewingManager: {url: "/apar/appraisal-review-list", permissionId: 0},
    aparReviewingManagerForm1: {url: "/apar/appraisal-review/add", permissionId: 0},
    aparReviewingManagerForm2: {url: "/apar/appraisal-review/add-personal-attributes", permissionId: 0},
    aparReviewingManagerForm3: {url: "/apar/appraisal-review/add-review", permissionId: 0},
    // acceptingManagerEmployees: {url: "/apar/accepting-manager-employees", permissionId: permissions.aparHRAccess},
    acceptingManagerReport:{url:"/apar/accepting-manager-report", permissionId: 0 },
    appraisalAcceptanceManager: {url: "/apar/appraisal-acceptance-manager", permissionId: 0},
    aparAcceptingManagerForm1: {url: "/apar/appraisal-acceptance/add", permissionId: 0},
    aparAcceptingManagerForm2: {url: "/apar/appraisal-acceptance/add-Weighted", permissionId: 0},
    aparAcceptingManagerForm3: {url: "/apar/appraisal-acceptance/add-personal-attributes", permissionId: 0},
    hrReportDetailList: { url: "/apar/view-reports/detail", permissionId: permissions.aparHRAccess },
    hrReportDetail: { url: "/apar/view-reports/detail/form", permissionId: permissions.aparHRAccess },
    aparPeriodOfAbsence: { url: "/apar/period-of-absence/:code", permissionId: permissions.aparHRAccess },
    aparQualificationsTraining: { url: "/apar/qualifications-training/:code", permissionId: permissions.aparHRAccess },
    aparOtherDetails: { url: "/apar/other-details/:code", permissionId: permissions.aparHRAccess },
    aparBulkUploadAuthority: { url: "/apar/bulk-upload-authority", permissionId: permissions.aparHRAccess },
    aparHrDownloadReports: { url: "/apar/hr-download-reports", permissionId: permissions.aparHRAccess },
    aparEmployeeFullDetailView: { url: "/apar/employee-full-detail", permissionId: 0 },
    employeeCompletedReport: { url: "/apar/employee-completed-report", permissionId: 0 },
    hrAparFullReport: { url: "/apar/hr-apar-full-report", permissionId: permissions.aparHRAccess },

    // user admin access
    adminLoginAs: {
      url: "/admin/login-as",
      permissionId: permissions.userAdminAccess,
    },

    adminDashboard: {
      url: "/admin",
      permissionId: permissions.userAdminAccess,
    },
    adminUserList: {
      url: "/admin/user",
      permissionId: permissions.userAdminAccess,
    },
    adminSearchUser: {
      url: "/admin/user/search",
      permissionId: permissions.userAdminAccess,
    },

    adminAddUser: {
      url: "/admin/user/add",
      permissionId: permissions.userAdminAccess,
    },
    adminEditUser: {
      url: "/admin/user/:code",
      permissionId: permissions.userAdminAccess,
    },
    adminUploadUserExcel: {
      url: "/admin/user/excel",
      permissionId: permissions.userAdminAccess,
    },

    adminDepartmentList: {
      url: "/admin/department",
      permissionId: permissions.userAdminAccess,
    },
    adminAddDepartment: {
      url: "/admin/department/add",
      permissionId: permissions.userAdminAccess,
    },

    adminDesignationList: {
      url: "/admin/designation",
      permissionId: permissions.userAdminAccess,
    },
    adminAddDesignation: {
      url: "/admin/designation/add",
      permissionId: permissions.userAdminAccess,
    },
    adminEditDesignation: {
      url: "/admin/designation/:code",
      permissionId: permissions.userAdminAccess,
    },

    adminPrintLog: {
      url: "/admin/print-log",
      permissionId: permissions.userAdminAccess,
    },

    adminUnitList: {
      url: "/admin/unit",
      permissionId: permissions.userAdminAccess,
    },
    adminAddUnitList: {
      url: "/admin/unit/add",
      permissionId: permissions.userAdminAccess,
    },

    adminGroupList: {
      url: "/admin/group",
      permissionId: permissions.userAdminAccess,
    },
    adminAddGroupList: {
      url: "/admin/group/add",
      permissionId: permissions.userAdminAccess,
    },

    adminGradeList: {
      url: "/admin/grade",
      permissionId: permissions.userAdminAccess,
    },
    adminAddGradeList: {
      url: "/admin/grade/add",
      permissionId: permissions.userAdminAccess,
    },

    adminAddHoliday: {
      url: "/admin/holiday/add",
      permissionId: permissions.userAdminAccess,
    },
    adminEditHoliday: {
      url: "/admin/holiday/:code",
      permissionId: permissions.userAdminAccess,
    },
    adminExcelHoliday: {
      url: "/admin/holiday/excel",
      permissionId: permissions.userAdminAccess,
    },
    adminHolidayList: {
      url: "/admin/holiday",
      permissionId: permissions.userAdminAccess,
    },

    adminNoting: {
      url: "/admin/noting",
      permissionId: permissions.userAdminAccess,
    },
    adminAddNoting: {
      url: "/admin/noting/add",
      permissionId: permissions.userAdminAccess,
    },
    adminEditNoting: {
      url: "/admin/noting/edit/:code",
      permissionId: permissions.userAdminAccess,
    },
    adminDak: { url: "/admin/dak", permissionId: permissions.userAdminAccess },
    // user admin access

    // hod report
    userFileReport: {
      url: "/file/report",
      permissionId: permissions.hodFileReport,
    },
    pendingHodFiles: {
      url: "/file/hod/pending",
      permissionId: permissions.hodFileReport,
    },
    hodApproveFile: {
      url: "/file/hod/approve",
      permissionId: permissions.hodFileReport,
    },

    // hod report
    approvedFileReport: { url: "/app-file/report", permissionId: 0 },

    // user routes

    userFileList: { url: "/file", permissionId: 0 },
    myFiles: { url: "/user/myfiles", permissionId: 0 },
    inbox: { url: "/user/inbox", permissionId: 0 },
    outbox: { url: "/user/outbox", permissionId: 0 },

    circularList: { url: "/circular-list", permissionId: 0 },

    dltFIles: { url: "/delete/files", permissionId: 0 },

    userClosedFileList: { url: "/file/closed", permissionId: 0 },
    userParkedFileList: { url: "/file/parked", permissionId: 0 },

    userParkedFileCommentDetails: {
      url: "/file/parked/details/:code",
      permissionId: 0,
    },
    intiateParkedFile: {
      url: "/file/parked/re-intiate/:fileCode",
      permissionId: 0,
    },

    userAddFile: { url: "/file/add", permissionId: 0 },
    circularListAdd: { url: "/circular/form", permissionId: 0 },
    circularFileDetail: {
      url: "/file/circular/detail/:fileCode",
      permissionId: 0,
    },

    userFileDetail: { url: "/file/:code", permissionId: 0 },
    userSearchFile: { url: "/file/search", permissionId: 0 },

    userETourList: { url: "/etour", permissionId: 0 },

    listMedicalClaim: { url: "/medicalClaim/list", permissionId: 0 },
    EmpPropertyReturn: { url: "/emp/property-return", permissionId: 0 },
    EmpPropertyReturnForHr: { url: "/hr/property-return-list", permissionId: permissions.admin_emp_property },
    medicalDesk: { url: "/medical/desk", permissionId: 0 },
    addMedicalClaim: { url: "/medicalClaim/add", permissionId: 0 },
    medicalClaimList: { url: "/medical/claim/list/:code", permissionId: 0 },

    userAddETour: { url: "/etour/request", permissionId: 0 },
    userETourDetail: { url: "/etour/:code", permissionId: 0 },

    DraftList: { url: "/draft-files", permissionId: 0 }, //new

    userReimbursementDetail: {
      url: "/etour/:code/reimbursement",
      permissionId: 0,
    },
    userAddReimbursementDetail: {
      url: "/reimbursement/:code",
      permissionId: 0,
    },

    userProfile: { url: "/profile", permissionId: 0 },
    userChangePassword: { url: "/change-password", permissionId: 0 },

    userLeaveList: { url: "/leave", permissionId: 0 },
    userApplyLeave: { url: "/leave/apply", permissionId: 0 },
    userLeaveDetail: { url: "/leave/detail/:code", permissionId: 0 },

    userLeaveEncashmentList: { url: "/encashment", permissionId: 0 },
    userLeaveEncashmentApply: { url: "/encashment/add", permissionId: 0 },
    userLeaveEncashmentDetail: {
      url: "/encashment/detail/:code",
      permissionId: 0,
    },

    superUser: { url: "/super-user", permissionId: 0 },
    superUserDashboard: { url: "/super-user-dashboard", permissionId: 0 },

    knowledgeManagementSystem: { url: "/knowledge", permissionId: 0 },
    dakManagementCreate: { url: "/dak/create", permissionId: 0 },
    dakManagementList: { url: "/dak/list", permissionId: 0 },
    dakManagementUpdate: { url: "/dak/update", permissionId: 0 },
    UploadToBank: { url: "/bank/upload/", permissionId: 0 },

    // user routes

    // admin leave management
    adminSearchLeave: {
      url: "/leave/search",
      permissionId: permissions.leaveAdminAccess,
    },
    adminMonthlyLeaveReport: {
      url: "/leaves/monthly",
      permissionId: permissions.leaveAdminAccess,
    },
    adminLeaveManager: {
      url: "/leave/management",
      permissionId: permissions.leaveAdminAccess,
    },
    adminLeaveReport: {
      url: "/leave/report",
      permissionId: permissions.leaveAdminAccess,
    },
    adminAddLeave: {
      url: "/leave/add",
      permissionId: permissions.leaveAdminAccess,
    },
    adminBulkUpdateLeave: {
      url: "/leave/bulk-update",
      permissionId: permissions.leaveAdminAccess,
    },
    adminBulkUploadLeaveBalance: {
      url: "/leave/bulk-balance",
      permissionId: permissions.leaveAdminAccess,
    },
    adminOrganisationLeaveRequestList: {
      url: "/leave/leave-request",
      permissionId: permissions.leaveAdminAccess,
    },
    adminOrganisationEncashmentRequestList: {
      url: "/encashment/encashment-request",
      permissionId: permissions.leaveAdminAccess,
    },
    adminOrganisationLeaveRequestDetail: {
      url: "/leave/leave-request/detail/:code",
      permissionId: permissions.leaveAdminAccess,
    },
    adminOrganisationEncashmentRequestDetail: {
      url: "/encashment/encashment-request/detail/:code",
      permissionId: permissions.leaveAdminAccess,
    },
    adminLeaveBalanceUpdateLog: {
      url: "/leave/update-log",
      permissionId: permissions.leaveAdminAccess,
    },
    // admin leave management

    // unit leave management
    unitLeaveReport: {
      url: "/unit/leave",
      permissionId: permissions.unitLeaveAdminAccess,
    },
    unitBulkUpdateLeave: {
      url: "/unit/bulk-update",
      permissionId: permissions.unitLeaveAdminAccess,
    },
    unitProxyLeaveList: {
      url: "/unit/leave-request",
      permissionId: permissions.unitLeaveAdminAccess,
    },
    unitProxyLeaveRequest: {
      url: "/unit/leave-request/add",
      permissionId: permissions.unitLeaveAdminAccess,
    },
    unitProxyLeaveDetail: {
      url: "/unit/leave-request/detail/:code",
      permissionId: permissions.unitLeaveAdminAccess,
    },
    unitAddLeave: {
      url: "/unit/add",
      permissionId: permissions.leaveAdminAccess,
    },
    // unit leave management
    unitEncashmentList: {
      url: "/unit/encashment-request",
      permissionId: permissions.unitLeaveAdminAccess,
    },

    // Efilling management

    eFilling: { url: "/add/Efilling", permissionId: 0 },
  },
  cookie: {
    token: "apar.ui.token",
    crossAppToken: "epil.ui.token",
    userDetail: "apar.ui.ud",
    navBarToggle: "navbar.toggle",
    recipients: "apar.ui.recipients",
    permissions: "apar.ui.permissions",
    selectedCycleId: "apar.ui.selectedCycleId",
    hrDealingOfficerList: "apar.ui.hrDealing",
    hrexecutive: "apar.ui.hrexecutive",
    finance: "apar.ui.finance",
    superUserToken: "super-user-token",
  },
  pageTitle: {
    home: "EPIL - Engineering Project (India) Ltd.",
    contact: "Support -  Engineering Project (India) Ltd.",
    login: "Login -  Engineering Project (India) Ltd.",
    logout: "Logout -  Engineering Project (India) Ltd.",

    forgotPassword: "Forgot password -  Engineering Project (India) Ltd.",
    changePassword: "Change password -  Engineering Project (India) Ltd.",
    resetPassword: "Reset password -  Engineering Project (India) Ltd.",
    profile: "Profile -  Engineering Project (India) Ltd.",
    leave: "Leave -  Engineering Project (India) Ltd.",
    etour: "E-Tour -  Engineering Project (India) Ltd.",
    allFiles: "All files -  Engineering Project (India) Ltd.",
    allLeaves: "All Leaves -  Engineering Project (India) Ltd.",
    allEtours: "All E-Tours -  Engineering Project (India) Ltd.",
    fileDetail: "File detail -  Engineering Project (India) Ltd.",
    leaveDetail: "Leave detail -  Engineering Project (India) Ltd.",
    etourDetail: "E-Tour detail -  Engineering Project (India) Ltd.",
    encashmentDetail: "Encashment detail -  Engineering Project (India) Ltd.",
    reimbursementDetail:
      "E-Tour Reimbursement detail -  Engineering Project (India) Ltd.",
    adminSection: "Admin section -  Engineering Project (India) Ltd.",
    fourZeroFour: "404 -  Engineering Project (India) Ltd.",
  },

  static: {
    locale: "en-IN",
    currency: "INR",
    currencySymbol: "₹",
    apiStatus: {
      success: "success",
      failed: "failed",
    },
    fileStatus: [
      { code: "true", name: "Park The File" },
      { code: "false", name: "Keep it open" },
    ],
    userType: {
      admin: { code: 1, name: "Administrator" },
      user: { code: 2, name: "User" },
      leaveManager: { code: 3, name: "Leave manager" },
      adminPlusHR: { code: 4, name: "Admin+HR" },
      superAdmin: { code: 5, name: "SuperAdmin" },
    },
    leaveDuration: [
      { code: 1, name: "First Half" },
      { code: 2, name: "Second Half" },
      { code: 3, name: "Full Day" },
    ],
    noting: {
      approved: 1,
    },
    permissions: permissions,
    approvalStatus: {
      pending: 0,
      approved: 1,
      rejected: 2,
      discuss: 3,
    },

    reimbursementTypeBills: {
      travelFareBills: "TFB",
      roadMilageBills: "RMB",
      hotelAllowanceBills: "HAB",
      cashAllowanceBills: "CAB",
    },
    leaveType: {
      cl: 1,
      el: 2,
      nonel: 3,
      hpl: 4,
      mat: 5,
      cml: 6,
      rh: 7,
    },

    daysOfWeek: [
      { code: 0, name: "Sunday" },
      { code: 1, name: "Monday" },
      { code: 2, name: "Tuesday" },
      { code: 3, name: "Wednesday" },
      { code: 4, name: "Thursday" },
      { code: 5, name: "Friday" },
      { code: 6, name: "Saturday" },
    ],
  },

  version: {
    web: 11,
  },

  organisation: {
    name: "EPI",
  },

  filterType: {
    default: "",
    f1: "keyword",
    f2: "bulk",

    corporate: {
      default: "corporate:default",
      f1: "corporate:keyword",
      f2: "corporate:bulk",
    },

    regional: {
      default: "regional:default",
      f1: "regional:keyword",
      f2: "regional:bulk",
    },
  },

  corporate_dpt_id: [
    33, 35, 45, 36, 34, 46, 42, 37, 44, 43, 40, 42, 41, 82, 81, 87, 84, 71,
  ],
  regional_dpt_id: [47, 49, 51, 48, 50],
};
